module.exports = __webpack_public_path__ + "img/catE.74715209.svg";